import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => {
  return {
    contentWrapper: {
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(0),
      },
    },
    container: {
      'userSelect': 'none',
      'textAlign': 'center',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: theme.spacing(6),
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    mobileContainer: {
      'userSelect': 'none',
      'textAlign': 'center',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: theme.spacing(0),
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },    
    aboutText: {
      'fontFamily': 'Roboto',
      fontSize: '16px',
      marginBottom: '2rem',
    },
    mobileAboutText: {
      'fontFamily': 'Roboto',
      fontSize: '12px',
      marginBottom: '1rem',
    },
    aboutTextBold: {
      'fontFamily': 'Roboto',
      fontSize: '30px',
      marginBottom: '2rem',
      fontWeight: 'bold',
    },
    mobileAboutTextBold: {
      'fontFamily': 'Roboto',
      fontSize: '15px',
      marginBottom: '1rem',
      fontWeight: 'bold',
    },
    icon: {
      width: '100%',
      height: '100%',
      color: theme.palette.secondary.main,
    },
    iconBox: {
      width: 50,
      'marginRight': 10,
    },
    title: {
      'fontWeight': 100,
      'fontFamily': 'Pacifico',
      'fontSize': '45px',
    },
    mobileTitle: {
      'fontWeight': 100,
      'fontFamily': 'Pacifico',
      'fontSize': '25px',
    },
    italicize: {
      'fontStyle': 'italic',
    },
    signUpButton: {
      mt: 2,
      mb: 2,
      fontSize: '1.2rem',
      padding: '15px 40px',
      borderRadius: '30px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      '&:hover': {
        boxShadow: '0 6px 8px rgba(0, 0, 0, 0.2)',
      },
    },
    mobileSignUpButton: {
      mt: 0,
      mb: 2,
      fontSize: '1.2rem',
      padding: '5px 40px',
      borderRadius: '30px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      '&:hover': {
        boxShadow: '0 6px 8px rgba(0, 0, 0, 0.2)',
      },
    },
  };
});

export default useStyles;